import { render } from "./Create.vue?vue&type=template&id=3c5eec75&scoped=true"
import script from "./Create.vue?vue&type=script&lang=js"
export * from "./Create.vue?vue&type=script&lang=js"

import "./Create.vue?vue&type=style&index=0&id=3c5eec75&scoped=true&lang=css"
import "./Create.vue?vue&type=style&index=1&id=3c5eec75&lang=css"

import exportComponent from "/home/dyam/Documentos/PROYECTOS/CERAMICAS/mi-stock/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c5eec75"]])

export default __exports__